import React from "react";
import { useState, useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
import "./notification.css"

const Notification = () => {

    const [notificationOpen, closeNotification] = useState(true);

    useEffect(() => {
        const data = window.sessionStorage.getItem("notificationOpen");
        if (data !== null) closeNotification(JSON.parse(data))
    }, [])
    useEffect(() => {
        window.sessionStorage.setItem("notificationOpen", JSON.stringify(notificationOpen))
    }, [notificationOpen])

    return (
        <>
            {notificationOpen ?
                <div className="notification">
                    <button className="notificationButton" onClick={() => closeNotification((prev) => !prev)}>
                        <CloseIcon className="notificationIcon" />
                    </button>
                    <p>

                        <b>Liebe Patientinnen und Patienten,</b> <br></br><br></br>

                        Aufgrund der heutigen Umstellung auf Glasfaser sind wir derzeit leider telefonisch nicht erreichbar.<br></br><br></br>

                        Wir arbeiten bereits mit Hochdruck daran, unsere Telefonanlage schnellstmöglich wieder in Betrieb zu nehmen.<br></br>

                        In der Zwischenzeit können Sie uns gerne per E-Mail kontaktieren. Wir bemühen uns, Ihre Nachrichten schnellstmöglich zu beantworten.
                        
                        

                        Wir bitten Sie um Verständnis und entschuldigen uns für die entstandenen Unannehmlichkeiten.<br></br><br></br>
                        
                        Vielen Dank für Ihre Geduld!<br></br><br></br>

                        <b>Herzliche Grüße</b><br></br>
                        Ihr Praxisteam der Kieferorthopädie
                    </p>
                </div>
                :
                ''
            }
        </>
    )
}

export default Notification